<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Operation</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper content-padding">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
            <form class="table-row-container row first-row filter" [formGroup]="operationFilterForm" (ngSubmit)="filter()" *ngIf="operationFilterForm">
                <div class="item data-col-10 hideOnPhoneView">
                    <h4 class="title" (click)="navigateOrder('Operation.id')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('Operation.id')"></i>
                      ID
                    </h4>
                    <span class="data">
                      <input type="number" formControlName="Operation.id" min="1000" max="10000" >
                    </span>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.surname')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                    Cognome
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="User.surname">
                  </span>
                </div>
                <div class="item data-col-15 expertClass">
                  <h4 class="title" (click)="navigateOrder('User.name')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                    Nome</h4>
                  <span class="data">
                    <input type="text" formControlName="User.name">
                  </span>
                </div>
                <div class="item data-col-15 center expertClass">
                  <h4 class="title" (click)="navigateOrder('User.email')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                    Email</h4>
                  <span class="data">
                    <input type="text" formControlName="User.email">
                  </span>
                </div>
                <div class="item data-col-10 center expertClass">
                  <h4 class="title" (click)="navigateOrder('Operation.phone')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Operation.phone')"></i>
                    Telefono</h4>
                  <span class="data">
                    <input type="text" formControlName="Operation.phone">
                  </span>
                </div>

                <div class="item data-col-15 center">
                  <h4 class="title" (click)="navigateOrder('User.active')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
                    Attivo</h4>
                  <span class="data">
                    <select formControlName="User.active">
                      <option value="">Tutti</option>
                      <option value="1">Attivo</option>
                      <option value="-1">Disattivo</option>
                    </select>
                  </span>
                </div>

                <div class="item nowrap">
                  <h4 class="title hide-on-mobile">AZIONI</h4>
                  <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                      RICERCA <i class="fas fa-search"></i></button>
                      <br/>
                    <button class="btn vertical align-items-center" (click)="resetFilter();">
                      RESET <i class="fas fa-times-circle"></i></button>
                  </span>
                </div>
            </form>

            <div class="table-row-container row" *ngFor="let operation of operations">

                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      ID
                    </h4>
                    <div class="data data-id">
                      <div>{{ operation?.id || "---" }}</div>
                    </div>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.surname')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                    Cognome</h4>
                  <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.user?.surname || "---" }}</a></span>
                </div>

                <div class="item data-col-15">
                  <h4 class="title" (click)="navigateOrder('User.name')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                    Nome</h4>
                  <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.user?.name || "---" }}</a></span>
                </div>

                <div class="item data-col-15 center">
                  <h4 class="title" (click)="navigateOrder('User.email')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                    Email</h4>
                  <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.user?.email || "---" }}</a></span>
                </div>

                <div class="item data-col-10 center">
                  <h4 class="title" (click)="navigateOrder('Operation.phone')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Operation.phone')"></i>
                    Telefono</h4>
                  <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.phone || "---" }}</a></span>
                </div>

                <div class="item data-col-10 center active">
                  <h4 class="title">
                    Attivo
                  </h4>
                  <span class="data">
                    {{ translateActive(operation?.user?.active) }}
                  </span>
                </div>

              <div class="item nowrap">
                <span class="data-row-left btn-container">
                  <button class="btn vertical align-items-center" [routerLink]="['/operation/edit', operation?.id]">
                    Modifica
                  </button>
                  <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteOperation(operation?.id)">
                    Elimina<i class="ml-10 far fa-trash-alt"></i>
                  </button>
                </span>
              </div>
            </div>
        </div>
    </section>

  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Operation</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center full-width-btn" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="operationFilterForm" (ngSubmit)="filter()" *ngIf="operationFilterForm">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Operation.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Operation.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="Operation.id" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.surname')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                Cognome
              </h4>
              <span class="data">
                <input type="text" formControlName="User.surname">
              </span>
            </div>
            <div class="item data-col-15 expertClass">
              <h4 class="title" (click)="navigateOrder('User.name')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                Nome</h4>
              <span class="data">
                <input type="text" formControlName="User.name">
              </span>
            </div>
            <div class="item data-col-15 center expertClass">
              <h4 class="title" (click)="navigateOrder('User.email')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                Email</h4>
              <span class="data">
                <input type="text" formControlName="User.email">
              </span>
            </div>
            <div class="item data-col-10 center expertClass">
              <h4 class="title" (click)="navigateOrder('Operation.phone')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Operation.phone')"></i>
                Telefono</h4>
              <span class="data">
                <input type="text" formControlName="Operation.phone">
              </span>
            </div>

            <div class="item data-col-15 center">
              <h4 class="title" (click)="navigateOrder('User.active')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
                Attivo</h4>
              <span class="data">
                <select formControlName="User.active">
                  <option value="">Tutti</option>
                  <option value="1">Attivo</option>
                  <option value="-1">Disattivo</option>
                </select>
              </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i></button>
                  <br/>
                <button class="btn vertical align-items-center" (click)="resetFilter();">
                  RESET <i class="fas fa-times-circle"></i></button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let operation of operations">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ operation?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.surname')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
                Cognome</h4>
              <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.user?.surname || "---" }}</a></span>
            </div>

            <div class="item data-col-15">
              <h4 class="title" (click)="navigateOrder('User.name')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
                Nome</h4>
              <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.user?.name || "---" }}</a></span>
            </div>

            <div class="item data-col-15 center">
              <h4 class="title" (click)="navigateOrder('User.email')">
                <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
                Email</h4>
              <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.user?.email || "---" }}</a></span>
            </div>

            <div class="item data-col-10 center">
              <h4 class="title" (click)="navigateOrder('Operation.phone')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Operation.phone')"></i>
                Telefono</h4>
              <span class="data"><a [routerLink]="['/operation', 'edit', operation.id]">{{ operation?.phone || "---" }}</a></span>
            </div>

            <div class="item data-col-10 center active">
              <h4 class="title">
                Attivo
              </h4>
              <span class="data">
                {{ translateActive(operation?.user?.active) }}
              </span>
            </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container">
              <button class="btn vertical align-items-center" [routerLink]="['/operation/edit', operation?.id]">
                Modifica
              </button>
              <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteOperation(operation?.id)">
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>
            </span>
          </div>
        </div>
    </div>
</section>
-->